/**
 * 培训管理  课程表管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>课程表管理</el-breadcrumb-item>
    </el-breadcrumb>


    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="queryParams" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="queryParams.className" placeholder="输入班级名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="queryParams.jsmc" placeholder="输入教室名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker size="small" type="datetime" placeholder="选择开始时间" v-model="queryParams.startTime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;"></el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker size="small" type="datetime" placeholder="选择结束时间" v-model="queryParams.endTime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;"></el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-select size="small" v-model="queryParams.dkfs" clearable placeholder="请选择签到方式">
          <el-option label="手机签到" :value="1"></el-option>
          <el-option label="设备签到" :value="2"></el-option>
          <el-option label="设备/手机签到" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-search" @click="download">导出</el-button>
      </el-form-item>
    </el-form>


    <!--列表-->
    <el-table size="small" :data="listData" ref="tableBox1" highlight-current-row v-loading="loading"
              border element-loading-text="拼命加载中" style="width: 100%;"
              @selection-change="handleSelectionChange"
              :row-key="(row) => { return row.id }">
      <el-table-column type="selection" width="55" align="center" :reserve-selection="true" />
      <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60"/>
      <el-table-column prop="className" label="班级名称" width="200"/>
      <el-table-column prop="kcmc" label="课程名称"/>
      <el-table-column prop="jsmc" label="教室名称"/>
      <el-table-column prop="xs" label="学时" width="80"/>
      <el-table-column prop="startTime" label="开始时间"/>
      <el-table-column prop="endTime" label="结束时间"/>
      <el-table-column prop="dkfs" label="签到方式">
        <template slot-scope="scope">
          <div>{{scope.row.dkfs == 1 ? '手机签到' : scope.row.dkfs == 2 ? '设备签到' : scope.row.dkfs == 3 ? '设备/手机签到' : '未签到'}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="ycdksj" label="延长打卡时间（分钟）"/>
      <el-table-column prop="bjrs" label="班级人数"/>
      <el-table-column prop="qdrs" label="签到人数">
        <template slot-scope="scope">
          <el-link v-if="Number(scope.row.qdrs) > 0" type="primary" @click="openQdrs(scope.row)">
            <span>{{ scope.row.qdrs }}</span>
          </el-link>
          <span v-else>{{ scope.row.qdrs }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="qtrs" label="签退人数">
        <template slot-scope="scope">
          <el-link v-if="Number(scope.row.qtrs) > 0" type="primary" @click="openQtrs(scope.row)">
            <span>{{ scope.row.qtrs }}</span>
          </el-link>
          <span v-else>{{ scope.row.qtrs }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" width="200">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <el-button
              size="mini"
              icon="el-icon-edit-outline"
              @click="handleEdit(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              @click="deleteUser(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            content="生成二维码"
            placement="top"
            v-if="scope.row.dkfs == 1 || scope.row.dkfs == 3"
          >
            <el-button
              size="mini"
              icon="el-icon-share"
              @click="sharePopup(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>
<!--          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>-->
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormShow" width="30%" :close-on-click-modal="false" @click="closeDialog">
      <el-form label-width="120px" :model="form" :rules="rules" ref="form">
        <el-table-column label="教室" prop="roomId">
          <template slot-scope="scope">
            <el-select v-model="form.roomId" placeholder="请选择" filterable>
              <el-option
                v-for="x in classroomList"
                :label="x.jsmc"
                :value="x.id"
                :key="x.id">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-form-item label="学时" prop="xs">
          <el-input size="small" v-model="form.xs" placeholder="请输入学时"></el-input>
        </el-form-item>
        <el-form-item  prop="startTime" label="开始时间">
          <el-date-picker type="datetime" placeholder="选择开始时间" v-model="form.startTime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item  prop="endTime" label="结束时间">
          <el-date-picker type="datetime" placeholder="选择结束时间" v-model="form.endTime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;"></el-date-picker>
        </el-form-item >
        <el-form-item prop="dkfs" label="签到方式">
          <el-select v-model="form.dkfs" placeholder="请选择">
            <el-option label="手机签到" :value="1" :key="1" />
            <el-option label="设备签到" :value="2" :key="2" />
            <el-option label="设备/手机签到" :value="3" :key="3" />
          </el-select>
        </el-form-item>
        <el-form-item prop="ycdksj" label="延长打卡时间（分钟）">
          <el-input size="small" v-model="form.ycdksj" placeholder="请输入" @input="formatInportData($event,'4','ycdksj',form)"></el-input>
        </el-form-item>
        <el-form-item label="授课教师" prop="jsxm">
          <el-input size="small" v-model="form.jsxm" placeholder="请输入授课教师"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('form')">保存</el-button>
      </div>
    </el-dialog>

    <!-- 二维码弹窗 -->
    <el-dialog :close-on-click-modal="false" title="课程二维码" width="300px" top="15vh" :visible.sync="shareShow" :before-close="handleClose" append-to-body>

      <el-image
        v-if="shareUrl"
        style="width: 200px; height: 200px"
        :src="shareUrl"
        :preview-src-list="[shareUrl]">
      </el-image>

    </el-dialog>

    <el-dialog
      :visible.sync="showProgress"
      :close-on-click-modal="false"
      :show-close="false"
      width="30%"
      top="30vh"
      custom-class="download-dialog"
    >
      <div class="download-content">
        <el-progress
          :percentage="progress"
          :status="progressStatus"
          :stroke-width="18"
          :text-inside="true"
        />
        <div class="progress-message" >
          {{ progressMessage }}
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  getMarketingChannelList,
  addMarketingChannel,
  editMarketingChannel,
  deleteMarketingChannel,
  getRoomList
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
import {timestampToTime} from "../../utils/util";
import Template from "../../components/template.vue";
import {
  courseExportDetail,
  deleteCourseTableById,
  editCourseTable,
  generateCode,
  getCourseTableList
} from "../../api/course";
export default {
  data() {
    return {
      ids: [],
      loading: false, //是显示加载
      editFormShow: false, //控制编辑页面显示与隐藏
      title: '添加',
      form: {},
      // rules表单验证
      rules: {
        marName: [
          { required: true, message: '请输入营销渠道名称', trigger: 'blur' }
        ],
        marCode: [
          { required: true, message: '请输入营销渠道编码', trigger: 'blur' }
        ]
      },
      queryParams: {
        page: 1,
        size: 10
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

      shareUrl: '',
      shareShow: false,

      classroomList: [],    // 教室

      showProgress: false,
      progress: 0,
      progressMessage: '文件下载中，请稍候...',
      progressStatus: null

    }
  },
  // 注册组件
  components: {
    Template,
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.initData()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    timestampToTime,
    indexMethod(index) {
      return (this.pageparm.currentPage - 1) * this.pageparm.pageSize + index + 1;
    },
    initData() {
      this.getdata()
      this.findClassroomList();
    },
    findClassroomList() {
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      getRoomList({page: 1, size: 99999}).then(res => {
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.classroomList = res.data.content
        }
      })
        .catch(err => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试！')
        })
    },
    // 获取 列表
    getdata() {
      this.loading = true

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      getCourseTableList(this.queryParams).then(res => {
        this.loading = false
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.listData = res.data.content
          // 分页赋值
          this.pageparm = res.data.pageparm
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('加载失败，请稍后再试！')
      })
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      console.log('selection  ', selection);
      if (selection.length > 1) {
        // this.$message.error('只能选择一条数据');
        this.$refs.tableBox1.clearSelection();
        this.$refs.tableBox1.toggleRowSelection(selection.pop());
      } else {
        this.ids = selection;
      }
    },
    // 分页插件事件
    callFather(parm) {
      this.queryParams.page = parm.currentPage
      this.queryParams.size = parm.pageSize
      this.getdata()
    },
    // 搜索事件
    search() {
      this.getdata()
    },
    // 生成二维码
    sharePopup(index, row) {
      console.log('row  ', row);
      generateCode(row).then(res => {
        if (res.code == 200) {
          this.shareUrl = "data:image/png; base64," + res.data;
          this.shareShow = true;
        }
      })
    },
    handleClose(done) {
      this.shareUrl = '';
      done();
    },

    // 跳转 签到情况页面
    openQdrs(row) {
      var {href} = this.$router.resolve({
        path: "/goods/signInStatus",
        query: {
          id: row.id,
          classId: row.classId,
          courseId: row.courseId,
          type: 1
        }
      })
      window.open(href, '_blank');
    },

    // 跳转 签到情况页面
    openQtrs(row) {
      // type 1：签到  2：签退
      var {href} = this.$router.resolve({
        path: "/goods/signInStatus",
        query: {
          id: row.id,
          classId: row.classId,
          courseId: row.courseId,
          type: 2
        }
      })
      window.open(href, '_blank');
    },

    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormShow = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.form = JSON.parse(JSON.stringify(row))
      } else {
        this.title = '添加'
        this.form = {}
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if (this.form.id) {
            // 修改

            var params = {
              id: this.form.id,
              roomId: this.form.roomId,
              startTime: this.form.startTime,
              endTime: this.form.endTime,
              xs: this.form.xs,
              dkfs: this.form.dkfs,
              ycdksj: this.form.ycdksj,
              jsxm: this.form.jsxm,
            }
            editCourseTable(params).then(res => {
              this.editFormShow = false
              this.loading = false
              if (res.code == 200) {
                this.getdata()
                this.form = {}
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormShow = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          }
        } else {
          return false
        }
      })
    },
    // 删除
    deleteUser(index, row) {
      this.$confirm('确定要删除该条数据吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteCourseTableById(row.id).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getdata()
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('删除失败，请稍后再试！')
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormShow = false
    },
    download(){
      if (this.ids.length == 0) {
        this.$message.error('请选择需要导出的数据');
        return;
      }


      window.open('/api/lesson/exportDetail?id=' + this.ids[0].id)

      /*// 初始化状态
      this.showProgress = true;
      this.progress = 0;
      this.progressStatus = null;
      this.progressMessage = '文件下载中，请稍候...';

      // 启动一个假的进度条
      this.timer = setInterval(() => {
        if (this.progress < 95) {
          this.progress += Math.random() * 3 // 模拟进度递增
        }
      }, 200)

      courseExportDetail(this.ids[0].id).then(res => {

        const blob = new Blob([res], { type: 'application/octet-stream' });
        // 创建a标签进行下载
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = '签到情况记录表.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // 下载完成状态
        clearInterval(this.timer)
        this.progress = 100;
        this.progressStatus = 'success';
        this.progressMessage = '下载完成！';

        // 2秒后自动关闭
        setTimeout(() => {
          this.showProgress = false;
        }, 2000);

      })*/

    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/goods/courseTableManage.vue